/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.23/esri/copyright.txt for details.
*/
import{glsl as e}from"../../shaderModules/interfaces.js";import{VertexAttribute as t}from"../../../lib/VertexAttribute.js";function o(o){o.attributes.add(t.POSITION,"vec2"),o.attributes.add(t.UV0,"vec2"),o.vertex.uniforms.add("u_scale","float"),o.vertex.uniforms.add("u_offset","vec2"),o.varyings.add("v_texcoord","vec2"),o.vertex.code.add(e`void main(void) {
v_texcoord = uv0 * u_scale + u_offset;
gl_Position = vec4(position, 0.0, 1.0);
}`)}export{o as BasicGrid};
